var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/IP"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6 1.5H2.4C1.6268 1.5 1 2.1268 1 2.9V14.1C1 14.8732 1.6268 15.5 2.4 15.5H13.6C14.3732 15.5 15 14.8732 15 14.1V2.9C15 2.1268 14.3732 1.5 13.6 1.5Z",
    stroke: "#454C58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "IP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.69141 4.5V12.5H4V4.5H5.69141Z",
    fill: "#6A82D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69801 12.5V4.5H9.85426C10.461 4.5 10.978 4.61589 11.405 4.84766C11.8321 5.07682 12.1576 5.39583 12.3816 5.80469C12.6082 6.21094 12.7214 6.67969 12.7214 7.21094C12.7214 7.74219 12.6069 8.21094 12.3777 8.61719C12.1485 9.02344 11.8165 9.33984 11.3816 9.56641C10.9493 9.79297 10.4259 9.90625 9.81129 9.90625H7.79957V8.55078H9.53785C9.86337 8.55078 10.1316 8.49479 10.3425 8.38281C10.5561 8.26823 10.7149 8.11068 10.8191 7.91016C10.9259 7.70703 10.9793 7.47396 10.9793 7.21094C10.9793 6.94531 10.9259 6.71354 10.8191 6.51562C10.7149 6.3151 10.5561 6.16016 10.3425 6.05078C10.129 5.9388 9.85816 5.88281 9.53004 5.88281H8.38941V12.5H6.69801Z",
    fill: "#6A82D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIp);
export default __webpack_public_path__ + "static/media/IP.86fb01fa72827480bc7c149db2ce0696.svg";
export { ForwardRef as ReactComponent };